import React from "react";

// Style \\
import "../../assets/styles/sections/serviceHero.scss";

const ServiceHero = () => {
  return (
    <section className="ServicetHero mb-20">
      <div className="ServiceHero_bg">
        <div className="containers">
          <div className="ServiceHero_items">
            <div className="ServicetHero_items_title">
              <p>Home / Service</p>
              <h2>Service</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
